import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from '@mui/icons-material/Search';
import DateRangeTableMission from './DateRangeTableMission'; 
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import PlanningMissionService from "../../../services/PlanningMissionService";
import Box from '@mui/material/Box';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import TableViewIcon from '@mui/icons-material/TableView';
import Message from "../../tools/Message";
import UserService from "../../../services/UserService";
import ExcelJS from 'exceljs';
import Typography from '@mui/material/Typography';
import { LoadingButton } from '@mui/lab';
import LoadingWithText from "../../tools/LoadingWithText";


function PlanningList(props) {
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
    const [filter, setFilter] = useState({
        date_debut: '',
        date_fin: '',
        direction: '',
        destination: '',
        status: '',
        directiondest: [],
        service: ''
    });
    const [dir, setDir] = useState(0);
    const [statistique, setStatistique] = useState([]);
    const [message, setMessage] = React.useState({
        open: false,
        color: "green",
        messageInfo: "",
    });
    const { open, color, messageInfo } = message;
    const [isLoading, setIsLoading] = useState(false);
    const [valdir, setValdir] = useState([]);
    const [direction, setDirection] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [datatable, setDatatable] = useState([]);
    const [service, setService] = useState([]);
    const [servicedet, setServicedet] = useState({});
    const [direcdetail, setDirect] = useState({});
    const [status, setStatus] = useState([]);
    const [defaultDirection, setDefaultDirection] = useState(null);

    const options = [
        { id: 'En attente de validation', label: 'En attente de validation' },
        { id: "Validé", label: 'Validé' },
        { id: 'Refusé', label: 'Refusé' },
    ];

 
    const StatItem = ({ label, value, color }) => (
        <Grid item xs={12} sm={6} md={3}>
          <Box
            sx={{
              border: `2px solid ${color}.main`,
              borderRadius: 2, 
              padding: 2, 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: `0 4px 8px rgba(0, 0, 0, 0.1)`,
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: `${color}.lighter`, 
                boxShadow: `0 6px 12px rgba(0, 0, 0, 0.2)`,
              },
            }}
          >
            <Typography variant="body2" color="text.secondary" fontWeight="medium">
              {label}
            </Typography>

            <Box
              component="span"
              color={`${color}.main`}
              sx={{
                fontWeight: 'bold',
                fontSize: '1.5rem', 
                marginTop: 1, 
              }}
            >
              {value}
            </Box>
          </Box>
        </Grid>
      );



    function handleChange(event) {
        const { name, value } = event.target;
        setFilter({ ...filter, [name]: value }); 
    }

    function handleChangeservice(event, value) {
        if (!value) {
            setServicedet({});
            setFilter({ ...filter, service: '' });
            return;
        }
        setServicedet(value);
        setFilter({ ...filter, service: value.service_id });
    }

    function handleChangeDirdestination(event, value) {
        setValdir(value || []);
        const iddir = (value || []).map(item => item.direction_id); 
        setFilter({ ...filter, directiondest: iddir });
    }

    function handleChangeDirection(event, value) {
        if (!value) {
            // Cas où l'utilisateur efface la sélection
            setFilter({ ...filter, direction: '', service: '' });
            setDirect({});
            setService([]);
            setServicedet({});
            return;
        }
        
        setFilter({ ...filter, direction: value.direction_id });
        setDirect(value);

        PlanningMissionService.getServiceappui(value.direction_id).then((result) => {
            if (result && result.data) {
                setService(result.data);
            }
        });
    }

    const generateDateRange = (debut, fin) => {
        const startDate = new Date(debut);
        const endDate = new Date(fin);
        const dates = [];
        let currentDate = new Date(startDate);
        
        while (currentDate <= endDate) {
            dates.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1); 
        }
        
        return dates;
    };

    const groupDaysByMonth = (dates) => {
        const months = {};
        
        dates.forEach(date => {
            const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`; 
            
            if (!months[monthKey]) {
                months[monthKey] = [];
            }
            
            months[monthKey].push(date.getDate());
        });
        
        return months;
    };

    const handleExportExcel = async () => {
        try {
            const dates = generateDateRange(filter.date_debut, filter.date_fin);
            const monthsGrouped = groupDaysByMonth(dates);

            // Colonnes fixes
            const columnsHeader = [
                { header: 'Référence de la mission', key: 'reference', width: 20 },
                { header: 'Direction', key: 'direction', width: 20 },
                { header: 'Service', key: 'service', width: 20 },
                { header: 'Matricule', key: 'matricule', width: 20 },
                { header: 'Nom et prénom(s)', key: 'name', width: 30 },
                { header: 'Fonction', key: 'fonction', width: 25 },
                { header: 'Objet de la mission', key: 'title', width: 30 },
                { header: 'Direction de destination', key: 'direction', width: 20 },
                { header: 'Région de destination', key: 'lieu', width: 20 },
                { header: 'District de destination', key: 'lieu', width: 20 },
                { header: 'Commune de destination', key: 'lieu', width: 25 },
                { header: 'Date de départ', key: 'debut', width: 20 },
                { header: 'Date de retour', key: 'retour', width: 20 },
                { header: 'Statut', key: 'status', width: 20 },
            ];

            const monthKeys = Object.keys(monthsGrouped).sort((a, b) => {
                const [yearA, monthA] = a.split('-').map(Number);
                const [yearB, monthB] = b.split('-').map(Number);
                return yearA === yearB ? monthA - monthB : yearA - yearB;
            });

            // Colonnes dynamiques par jour/mois
            monthKeys.forEach(monthKey => {
                const [year, month] = monthKey.split('-');
                monthsGrouped[monthKey].forEach(day => {
                    const label = `${day}/${month}`;
                    const key = `${day}-${month}-${year}`;
                    columnsHeader.push({ header: label, key, width: 10 });
                });
            });

            const getCellColor = (finalState) => {
                const colors = {
                    'En attente de validation': 'FFCECECE',
                    'Planifié': 'FF78B785',
                    'Nouveau': 'FF87CEEB',
                    'Validé': 'FF78B785',
                    'Refusé': 'FFFF0000'
                };
                return colors[finalState] || 'FFFFFFFF';
            };

            const data = [];
            const datacolor = [];

            datatable.forEach(ts => {
                const rowData = [
                    ts.reference,
                    ts.direction_code,
                    ts.service_code,
                    ts.registration_number,
                    ts.nom,
                    ts.function_code,
                    ts.mission_title,
                    ts.direction_dest,
                    ts.region,
                    ts.district,
                    ts.commune,
                    ts.date_debut,
                    ts.date_fin,
                    ts.final_state
                ];

                const rowColor = Array(rowData.length).fill('FFFFFFFF');

                const detailsMap = new Map();
                if (ts.details && Array.isArray(ts.details)) {
                    ts.details.forEach(detail => {
                        const key = `${detail.month_par_jour}-${detail.jour_par_jour}`;
                        detailsMap.set(key, detail);
                    });
                }

                monthKeys.forEach(monthKey => {
                    const currentMonth = parseInt(monthKey.split('-')[1], 10);
                    const monthDays = monthsGrouped[monthKey];

                    monthDays.forEach(day => {
                        const key = `${currentMonth}-${day}`;
                        const matchingDetail = detailsMap.get(key);

                        if (matchingDetail) {
                            rowData.push(matchingDetail.lieufinal || '');
                            rowColor.push(getCellColor(matchingDetail.final_state));
                        } else {
                            rowData.push('');
                            rowColor.push('FFFFFFFF');
                        }
                    });
                });

                data.push(rowData);
                datacolor.push(rowColor);
            });

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Planning des Missions');

            worksheet.columns = columnsHeader;

            // Appliquer les données avec styles
            data.forEach((rowData, rowIndex) => {
                const row = worksheet.addRow(rowData);

                row.eachCell({ includeEmpty: true }, (cell, colIndex) => {
                    const color = datacolor[rowIndex]?.[colIndex - 1];

                    if (color && color !== 'FFFFFFFF') {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: color }
                        };
                    }

                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                });
            });

            // Style de l'en-tête
            const headerRow = worksheet.getRow(1);
            headerRow.font = {
                bold: true,
                color: { argb: 'FFFFFFFF' },
                size: 12
            };
            headerRow.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF4472C4' }
            };
            headerRow.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            worksheet.getRow(1).height = 25;

            // Exportation
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const fileName = `planning_missions_${new Date().toISOString().split('T')[0]}.xlsx`;

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);

        } catch (error) {
            console.error('Erreur lors de l\'export Excel:', error);
            alert('Une erreur est survenue lors de l\'export. Veuillez réessayer.');
        }
    };



    function handleFilter() {
        if (filter.date_debut === '' || filter.date_fin === '') {
            setMessage({ ...message, open: true, color: 'red', messageInfo: "Veuillez indiquer les dates." });
            return;
        } 
        if (new Date(filter.date_debut) > new Date(filter.date_fin)) {
            setMessage({ ...message, open: true, color: 'red', messageInfo: "La date de début doit précéder la date de fin" });
            return;
        }
        setIsLoading(true);
        setOpenLoadingSimpleBackdrop(true);
        PlanningMissionService.getEtatplanning(filter).then((result) => {
            if (result) {
                setShowTable(true);
                setDatatable(result.data);   
                setStatistique(result.stat);
                if (result.data.length === 0) {
                    setMessage({ ...message, open: true, color: 'red', messageInfo: "Aucune donnée disponible pour le filtre sélectionné. Veuillez réinitialiser" });
                } 
                setIsLoading(false);
                setOpenLoadingSimpleBackdrop(false);
            }
            else {
                setShowTable(false);
                setIsLoading(false);
                setOpenLoadingSimpleBackdrop(false);
                setMessage({ ...message, open: true, color: 'red', messageInfo: "Aucune donnée disponible pour le filtre sélectionné. Veuillez réinitialiser" });
            }
          });
    }

    function handlereinitiale()
    {
        setFilter({
            date_debut: '',
            date_fin: '',
            direction: defaultDirection ? defaultDirection.direction_id : '',
            destination: '',
            status: [],
            directiondest: defaultDirection ? [defaultDirection.direction_id] : [],
            service: ''
        });
        setValdir(defaultDirection ? [defaultDirection] : []);
        setServicedet({});
        setDirect(defaultDirection || {});
        setStatus([]);
        setStatistique([]);
        setDatatable([]);
        setShowTable(false);

        // Recharger les services de la direction par défaut
        if (defaultDirection) {
            PlanningMissionService.getServiceappui(defaultDirection.direction_id).then((res) => {
                if (res && res.data) {
                    setService(res.data);
                }
            });
        }
    }

    const handleChangestatus = (event, newValue) => {
        if (!newValue) {
            setSelectedOptions(null);
            setStatus([]);
            setFilter({ ...filter, status: '' });
            return;
        }
        setSelectedOptions(newValue);
        setStatus(newValue);
        setFilter({ ...filter, status: newValue.id });
    };

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    useEffect(() => {
        const userData = localStorage.getItem('USER');
        if (userData) {
          UserService.getUserSummaryByUserId(userData)
            .then((result) => {
              if (result && result.data) {
                const dirpers = result.data.direction_id;
                PlanningMissionService.getDirection().then((result) => {
                  if (result && result.data) {
                    let directions = result.data;
                    if (parseInt(dirpers, 10) !== 1) { 
                      directions = result.data.filter(ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10));
                    }
                    setDirection(directions);
                    
                    // Définir la direction par défaut
                    if (directions.length > 0) {
                        const defaultDir = directions[0];
                        setDefaultDirection(defaultDir);
                        setValdir([defaultDir]);  // Direction destination
                        setDirect(defaultDir);     // Direction des missionnaires
                        setFilter(prev => ({
                            ...prev,
                            direction: defaultDir.direction_id,
                            directiondest: [defaultDir.direction_id]
                        }));
                        
                        // Charger les services de la direction par défaut
                        PlanningMissionService.getServiceappui(defaultDir.direction_id).then((res) => {
                            if (res && res.data) {
                                setService(res.data);
                            }
                        });
                    }
                  }
                }).catch((error) => {
                  console.error('Error fetching direction data:', error);
                });
              }
            })
            .catch((error) => {
              console.error('Error fetching user summary:', error);
            });
        }
      }, []);


    return (
        <>
            <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            <LoadingWithText openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
            <Grid container spacing={4}>
               <Grid item xs={2}>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={handleFilter}
                        loading={isLoading}
                        style={{
                            fontWeight: 600,
                            width: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        startIcon={<SearchIcon style={{ marginRight: '8px' }} />} 
                    >
                        Filtrer
                    </LoadingButton>
                </Grid>  
                <Grid item xs={2}>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handlereinitiale} 
                        style={{ fontWeight: 600, width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                    <RestartAltIcon style={{ marginRight: '8px' }} />
                        réinitialiser
                    </Button>
                </Grid>
                
                <Grid item xs={2}>
                   <Button
                        variant="contained"
                        color="#9E9E9E"
                        onClick={handleExportExcel} 
                        style={{ fontWeight: 600, width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <TableViewIcon style={{ marginRight: '8px' }} />
                        Export excel
                    </Button>
                </Grid>
                <Grid item xs={6}>
                </Grid>
                <Grid item xs={3}>
                     Date début:
                    <TextField
                        fullWidth
                        id="date_debut"
                        size="small"
                        variant="outlined"
                        type="date"
                        value={filter.date_debut}
                        name="date_debut"
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={3}>
                    Direction destination :
                    <Autocomplete
                        onChange={handleChangeDirdestination}
                        multiple
                        value={valdir}
                        name="direction"
                        options={direction}
                        getOptionLabel={(option) => `${option.name} (${option.code})`}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                size="small"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={3}>
                     Direction des missionnaires
                     <Autocomplete
                        onChange={handleChangeDirection}
                        name="direction"
                        options={direction}
                        value={direcdetail && direcdetail.direction_id ? direcdetail : null}
                        getOptionLabel={(option) => `${option.name} (${option.code})`}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                size="small"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                            />
                        )}
                    />
                       
                </Grid>
                <Grid item xs={3}>
                      Statut
                       <Autocomplete
                            onChange={handleChangestatus}
                            disableCloseOnSelect={false}
                            name="status"
                            options={options}
                            getOptionLabel={(option) => `${option.label}`}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, type: 'search' }}
                                />
                            )}
                        />
                </Grid>
                <Grid item xs={3}>
                     Date fin:
                    <TextField
                        fullWidth
                        id="date_fin"
                        size="small"
                        variant="outlined"
                        type="date"
                        value={filter.date_fin}
                        name="date_fin"
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={3}>
                        Référence de la mission :
                        <TextField
                                fullWidth
                                id="destination"
                                size="small"
                                variant="outlined"
                                value={filter.destination}
                                name="destination"
                                onChange={handleChange}
                        />
                </Grid>
               
                <Grid item xs={3}> 
                    Service des missionnaires
                     <Autocomplete
                       onChange={handleChangeservice}
                       value={servicedet && servicedet.service_id ? servicedet : null}
                        name="service"
                        options={service}
                        getOptionLabel={(option) => `${option.name} (${option.code})`}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                size="small"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={3}>      
                </Grid>
                <Grid item xs={3}>
                    <Box
                        component="span"
                        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: '#cecece' }}
                    >
                    </Box>
                    Planning en attente de validation 
                </Grid>
                <Grid item xs={3}>
                    <Box
                        component="span"
                        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: '#78b785' }}
                    >
                    </Box>
                    Planning validé 
                </Grid>
                <Grid item xs={3}>
                    <Box
                        component="span"
                        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', width: '15px', height: '15px', background: 'red' }}
                    >
                    </Box>
                    Planning refusé
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={12}> </Grid>
                <Grid item xs={12}> 
                <Grid container item xs={12} spacing={2}>
                   {Object.keys(statistique).length > 0 && (
                        <>
                            <StatItem label="Missions planifiées" value={statistique['Nombre de missions planifiées'] || 0} color="primary" />
                            <StatItem label="En attente de validation" value={statistique['En attente de validation'] || 0 } color="warning" />
                            <StatItem label="Validées" value={statistique['Planifié'] || 0 } color="success" />
                            <StatItem label="Refusées" value={statistique['Refusé'] || 0} color="error" />
                        </>
                    )}
                </Grid>
               </Grid>
           <Grid item xs={12}>
                    {showTable && filter.date_debut && filter.date_fin && (
                        <DateRangeTableMission
                            startDate={new Date(filter.date_debut)}
                            endDate={new Date(filter.date_fin)}
                            datatable={datatable}
                        />
                    )}
            </Grid>
           
          </Grid>
        </>
    );
}

export default PlanningList;